import React from 'react';
import { useTranslation } from 'react-i18next';
import type { FailureMode } from '../../../types/drbfm';
import { FailureModeCard, ReviewFailureMode } from './workbench/FailureModeCard';
import { WorkbenchSection } from './workbench/WorkbenchSection';

interface Props {
  failureModes: FailureMode[];
  isLoading: boolean;
  onReview: ReviewFailureMode;
}

const FailureModeWorkbench: React.FC<Props> = ({ failureModes, isLoading, onReview }) => {
  const { t } = useTranslation();
  return (
  <WorkbenchSection
    title={t('drbfm.workflow.workbenches.failureModeReviewTitle', '故障モードレビュー')}
    description={t('drbfm.workflow.workbenches.failureModeReviewDescription', 'AIの重大度は候補値です。S/O/Dを確認するまでRPNは確定しません。')}
    emptyMessage={t('drbfm.workflow.workbenches.failureModeEmpty', '故障モード候補はまだありません。')}
    isEmpty={failureModes.length === 0}
  >
    {failureModes.filter((mode) => mode.reviewStatus !== 'superseded').map((mode) => (
      <FailureModeCard key={mode.id} mode={mode} isLoading={isLoading} onReview={onReview} />
    ))}
  </WorkbenchSection>
  );
};

export default FailureModeWorkbench;
